<div class="header-wrapper row m-0">
    <ul class="nav-menus">
        <li class="language-nav">
            <div class="translate_wrapper">
                <div class="translate_wrapper">
                    <div class="current_lang">
                        <div class="lang">
                            <i class="flag-icon flag-icon-us"></i>
<!--                             <span class="lang-txt">EN</span>-->
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <li class="warehouse-header d-flex gap-2" @click="showListStoreHeader()">
            <div class="warehouse-name-header">{{ usingStoreName }}</div>
            <div class="arrow-menu">
                <IconCaretDown></IconCaretDown>
            </div>
            <ul class="warehouse-list-header" :class="{ 'd-none': !isStoreActive }">
                <li @click="selectStore(store)" v-for="store in storesList">
                    {{store.name}}
                </li>
            </ul>
        </li>
        <li class="user d-flex gap-2" @click="showMenuUser()">
            <div class="user-avatar d-flex">
                <IconUserDefault></IconUserDefault>
            </div>
            <div class="username">{{ username }}</div>
            <div class="arrow-menu">
                <IconCaretDown></IconCaretDown>
            </div>
            <ul class="user-menu" :class="{ 'd-none': !isActive }">
                <li @click="logout()">
                    Đăng xuất
                </li>
            </ul>
        </li>
        <li class="onhover-dropdown">
        </li>
    </ul>
</div>